const HUB_PREFIXES = [
  "https://",
  "docker.io/",
  "index.docker.io/",
  "registry-1.docker.io/",
  "hub.docker.com/r/"
]

const NAMESPACE = /^[a-z0-9]+$/
const NAME = /^[a-z0-9]+(?:[._-][a-z0-9]+)*$/

export const normalizeRepository = (value: string) => {
  let repository = value.trim().toLowerCase()

  HUB_PREFIXES.forEach((prefix) => {
    if (repository.startsWith(prefix))
      repository = repository.slice(prefix.length)
  })

  return repository.replace(/^\/+|\/+$/g, "")
}

export const getRepositoryProblem = (
  repository: string
): "invalid" | "official" | undefined => {
  const [namespace, name, ...rest] = repository.split("/")

  if (!name || rest.length || !NAMESPACE.test(namespace) || !NAME.test(name))
    return "invalid"
  if (namespace === "library") return "official"

  return undefined
}
